export const valorMaskKm = (value) => {
    if (value === 0 || value === null || value === undefined) {
        return "";
    } else if (value) {
        let stringValue = String(value);
        return stringValue.replace(/[^0-9]/g, '');
    } else {
        return "";
    }
};